




































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { getDefaultAccountOptions, getDefaultSystemSettings } from '@/components/helper'
import SystemSettings from '@/models/SystemSettings'
import AccountOptions from '@/models/AccountOptions'

@Component({})
export default class SettingsModuleComponent extends Vue {
    @Prop({ type: Object, default: () => ({}) })
    private currentSettingsModule: SystemSettings

    @Prop({ type: Object, default: () => ({}) })
    private currentAccountOptions: AccountOptions

    @Prop({ type: Boolean, default: true })
    private needToShowTestOption: boolean

    private selectedSettingsModule: SystemSettings = getDefaultSystemSettings()
    private selectedAccountOptions: AccountOptions = getDefaultAccountOptions()

    @Watch('currentSettingsModule')
    selectedSettings(): void {
        this.selectedSettingsModule = Object.assign({}, this.currentSettingsModule)
    }

    @Watch('currentAccountOptions')
    selectedOptions(): void {
        this.selectedAccountOptions = Object.assign({}, this.currentAccountOptions)
    }

    updateOption(code: string): void {
        if (this.selectedAccountOptions[code]) {
            this.$emit('updateAccountOptionEvent', this.selectedAccountOptions[code])
        }
    }

    updateSetting(codeSetting: string): void {
        if (this.selectedSettingsModule[codeSetting]) {
            this.$emit('updateSettingModule', this.selectedSettingsModule[codeSetting])
        }
    }
}
